import EditableFieldDef from "./EditableFieldDef";

const phaseFieldDefs = [
  new EditableFieldDef({
    fieldName: "phaseName",
    label: "Phase Name",
    required: true,
    type: "text",
  }), new EditableFieldDef({
    fieldName: "street",
    label: "Street Address",
    required: true,
    type: "text",
  }), new EditableFieldDef({
    fieldName: "city", // not editable
    label: "City",
    required: false,
    readonly: true,
    type: "text",
  }), new EditableFieldDef({
    fieldName: "state", // not editable
    label: "State",
    required: false,
    readonly: true,
    type: "text",
  }), new EditableFieldDef({
    fieldName: "zip5", // not editable
    label: "ZIP",
    required: false,
    readonly: true,
    type: "text",
  }), new EditableFieldDef({
    fieldName: "buildingNumber",
    label: "Building Number",
    required: false,
    type: "text",
  }), new EditableFieldDef({
    fieldName: "unitNumber",
    label: "Unit Number",
    required: false,
    type: "text",
  }), new EditableFieldDef({
    fieldName: "unitCount",
    label: "Number of Units in Phase",
    required: true,
    type: "number",
    validatePartial: value => /^[1-9]?[0-9]*$/.test(value),
    validateComplete: value => /^[1-9][0-9]*$/.test(value),
    invalidMessage: "Please enter a number greater than 0.",
  }),
];

export default phaseFieldDefs;